export const EVENT_ACTIVITIES_FORM = 'EVENT_ACTIVITIES_FORM';
export const ALCOHOLIC_BEVERAGE_FORM = 'ALCOHOLIC_BEVERAGE_FORM';
export const EVENT_RULES_FORM = 'EVENT_RULES_FORM';
export const FURNITURE_FORM = 'FURNITURE_FORM';
export const AV_MUSIC_FORM = 'AV_MUSIC_FORM';
export const FOOD_BEVERAGE_FORM = 'FOOD_BEVERAGE_FORM';
export const RESTROOM_FORM = 'RESTROOM_FORM';

export const EVENT_FAQ_CONST = {
  FOOD_BEVERAGE_RULES: 'food_beverage_rules',
  FOOD_PREP_RULES: 'food_prep_rules',
  FULL_KITCHEN: 'full_kitchen',
  COMMERCIAL_KITCHEN: 'commercial_kitchen',
  KITCHENETTE: 'kitchenette',
  PREP_AREA: 'prep_area',
  PLACE_SETTINGS: 'place_settings',
  SERVING_UTENSILS: 'serving_utensils',
  CUPS_GLASSES: 'cups_glasses',
  WINE_GLASSES: 'wine_glasses',
  BRING_ALCOHOL: 'bring_alcohol',
  BRING_ALCOHOL_RULES: 'bring_alcohol_rules',
  ALCOHOL_MUST_BE_SERVED_BY_LICENSED_VENDOR: 'alcohol_must_be_served_by_licensed_vendor',
  CAN_PURCHASE_ALCOHOL_AT_FULL_SERVICE_BAR: 'can_purchase_alcohol_at_full_service_bar',
  CAN_PURCHASE_BEER_WINE_AT_BAR: 'can_purchase_beer_wine_at_bar',
  OTHER_ALCOHOL_CONSUMPTION_RULES: 'other_alcohol_consumption_rules',
  TABLES: 'tables',
  CHAIRS: 'chairs',
  SOFT_SEATING: 'soft_seating',
  STANDARD_RESTROOMS: 'standard_restrooms',
  ADA_RESTROOMS: 'ada_restrooms',
  NURSING_ROOMS: 'nursing_rooms',
  MICROPHONES: 'microphones',
  PROJECTOR: 'projector',
  SPEAKERS: 'speakers',
  TELEVISION: 'television',
  MISC_AV_EQUIPMENT: 'misc_av_equipment',
  IS_DJ_ALLOWED: 'is_dj_allowed',
  IS_LIVE_MUSIC_ALLOWED: 'is_live_music_allowed',
  IS_AMPLIFIED_MUSIC_ALLOWED: 'is_amplified_music_allowed',
  IS_CONNECTED_AMPLIFIED_MUSIC_ALLOWED: 'is_connected_amplified_music_allowed',
  ARCADE_GAMES: 'arcade_games',
  DARTS: 'darts',
  KARAOKE: 'karaoke',
  PING_PONG_TABLE: 'ping_pong_table',
  POOL_TABLE: 'pool_table',
  SHUFFLEBOARD: 'shuffleboard',
  MISC_ACTIVITIES: 'misc_activities',
  IS_21ST_BDAY_PROHIBITED: 'is_21st_bday_prohibited',
  IS_AFTER_PARTY_PROHIBITED: 'is_after_party_prohibited',
  IS_ALBUM_RELEASE_PARTY_PROHIBITED: 'is_album_release_party_prohibited',
  IS_BACHELOR_PARTY_PROHIBITED: 'is_bachelor_party_prohibited',
  IS_CONCERT_PROHIBITED: 'is_concert_prohibited',
  IS_FESTIVAL_HOLIDAY_PARTY_PROHIBITED: 'is_festival_holiday_party_prohibited',
  IS_INFLUENCER_EVENT_PROHIBITED: 'is_influencer_event_prohibited',
  IS_KIDS_PARTY_PROHIBITED: 'is_kids_party_prohibited',
  IS_SPORTS_VIEWING_PARTY_PROHIBITED: 'is_sports_viewing_party_prohibited',
  IS_WEDDING_PROHIBITED: 'is_wedding_prohibited',
  IS_PARTY_PROHIBITED: 'is_party_prohibited',
  OTHER_PROHIBITED_ACTIVITY: 'other_prohibited_activity',
  HAS_QUIET_HOURS: 'has_quiet_hours',
  LOUD_MUSIC_ENDS_BY: 'loud_music_ends_by',
  HAS_FLEXIBLE_HOURS: 'has_flexible_hours',
  IS_GLITTER_ALLOWED: 'is_glitter_allowed',
  IS_HIRED_SECURITY_REQUIRED: 'is_hired_security_required',
  ARE_OPEN_FLAMES_ALLOWED: 'are_open_flames_allowed',
  ARE_PETS_ALLOWED: 'are_pets_allowed',
  IS_SMOKING_ALLOWED: 'is_smoking_allowed',
  ARE_TICKETED_EVENTS_ALLOWED: 'are_ticketed_events_allowed',
  OTHER_EVENT_RULES: 'other_event_rules'
};

export const EVENT_FAQ_ANSWERS_CONST = {
  OUTSIDE_FOOD_BEVERAGE_ALLOWED: 'outside_food_beverage_allowed',
  ON_SITE_FOOD_BEVERAGE: 'on_site_food_beverage',
  LICENSED_FOOD_BEVERAGE: 'licensed_food_beverage',
  OTHER_FOOD_AND_BEVERAGE_RULES: 'other_food_and_beverage_rules',
  NO_OUTSIDE_FOOD_BEVERAGE: 'no_outside_food_beverage',
  COOKING_AND_PREP_ALLOWED: 'cooking_and_prep_allowed',
  ONLY_FOOD_PREP: 'only_food_prep',
  NO_COOKING_ALLOWED: 'no_cooking_allowed',
  OTHER_FOOD_PREP_RULES: 'other_food_prep_rules',
  BRING_ALCOHOL_ALLOWED: 'bring_alcohol_allowed',
  BRING_ALCOHOL_NOT_ALLOWED: 'bring_alcohol_not_allowed',
  NO_ALCOHOL_ALLOWED: 'no_alcohol_allowed',
  ANY_ALCOHOL: 'any_alcohol',
  LIQUOR_NOT_ALLOWED: 'liquor_not_allowed',
  LICENSED_LIQUOR: 'licensed_liquor',
  HOURS_ADJUSTED_UPON_REQUEST: 'hours_adjusted_upon_request',
  HAS_NO_FLEXIBLE_HOURS: 'has_no_flexible_hours'
};

export const AMENITIES_LIST = new Set([
  EVENT_FAQ_CONST.FULL_KITCHEN,
  EVENT_FAQ_CONST.COMMERCIAL_KITCHEN,
  EVENT_FAQ_CONST.KITCHENETTE,
  EVENT_FAQ_CONST.PREP_AREA,
  EVENT_FAQ_CONST.PLACE_SETTINGS,
  EVENT_FAQ_CONST.SERVING_UTENSILS,
  EVENT_FAQ_CONST.CUPS_GLASSES,
  EVENT_FAQ_CONST.WINE_GLASSES,
  EVENT_FAQ_CONST.TABLES,
  EVENT_FAQ_CONST.CHAIRS,
  EVENT_FAQ_CONST.SOFT_SEATING,
  EVENT_FAQ_CONST.STANDARD_RESTROOMS,
  EVENT_FAQ_CONST.ADA_RESTROOMS,
  EVENT_FAQ_CONST.NURSING_ROOMS,
  EVENT_FAQ_CONST.MICROPHONES,
  EVENT_FAQ_CONST.PROJECTOR,
  EVENT_FAQ_CONST.SPEAKERS,
  EVENT_FAQ_CONST.TELEVISION,
  EVENT_FAQ_CONST.MISC_AV_EQUIPMENT,
  EVENT_FAQ_CONST.ARCADE_GAMES,
  EVENT_FAQ_CONST.DARTS,
  EVENT_FAQ_CONST.KARAOKE,
  EVENT_FAQ_CONST.PING_PONG_TABLE,
  EVENT_FAQ_CONST.POOL_TABLE,
  EVENT_FAQ_CONST.SHUFFLEBOARD,
  EVENT_FAQ_CONST.MISC_ACTIVITIES,
]);

export const FOOD_BEVERAGE_PROPS = [EVENT_FAQ_CONST.FOOD_BEVERAGE_RULES,
  EVENT_FAQ_CONST.FOOD_PREP_RULES,
  EVENT_FAQ_CONST.FULL_KITCHEN,
  EVENT_FAQ_CONST.COMMERCIAL_KITCHEN,
  EVENT_FAQ_CONST.KITCHENETTE,
  EVENT_FAQ_CONST.PREP_AREA,
  EVENT_FAQ_CONST.PLACE_SETTINGS,
  EVENT_FAQ_CONST.SERVING_UTENSILS,
  EVENT_FAQ_CONST.CUPS_GLASSES,
  EVENT_FAQ_CONST.WINE_GLASSES];

export const ALCOHOL_PROPS = [EVENT_FAQ_CONST.BRING_ALCOHOL,
  EVENT_FAQ_CONST.BRING_ALCOHOL_RULES,
  EVENT_FAQ_CONST.ALCOHOL_MUST_BE_SERVED_BY_LICENSED_VENDOR,
  EVENT_FAQ_CONST.CAN_PURCHASE_ALCOHOL_AT_FULL_SERVICE_BAR,
  EVENT_FAQ_CONST.CAN_PURCHASE_BEER_WINE_AT_BAR,
  EVENT_FAQ_CONST.OTHER_ALCOHOL_CONSUMPTION_RULES];

export const FURNITURE_PROPS = [EVENT_FAQ_CONST.TABLES, EVENT_FAQ_CONST.CHAIRS, EVENT_FAQ_CONST.SOFT_SEATING];

export const RESTROOM_PROPS = [EVENT_FAQ_CONST.STANDARD_RESTROOMS, EVENT_FAQ_CONST.ADA_RESTROOMS, EVENT_FAQ_CONST.NURSING_ROOMS];

export const AV_MUSIC_PROPS = [EVENT_FAQ_CONST.MICROPHONES,
  EVENT_FAQ_CONST.PROJECTOR,
  EVENT_FAQ_CONST.SPEAKERS,
  EVENT_FAQ_CONST.TELEVISION,
  EVENT_FAQ_CONST.MISC_AV_EQUIPMENT,
  EVENT_FAQ_CONST.IS_DJ_ALLOWED,
  EVENT_FAQ_CONST.IS_LIVE_MUSIC_ALLOWED,
  EVENT_FAQ_CONST.IS_AMPLIFIED_MUSIC_ALLOWED,
  EVENT_FAQ_CONST.IS_CONNECTED_AMPLIFIED_MUSIC_ALLOWED];

export const EVENT_ACTIVITIES_PROPS = [EVENT_FAQ_CONST.ARCADE_GAMES,
  EVENT_FAQ_CONST.DARTS,
  EVENT_FAQ_CONST.KARAOKE,
  EVENT_FAQ_CONST.PING_PONG_TABLE,
  EVENT_FAQ_CONST.POOL_TABLE,
  EVENT_FAQ_CONST.SHUFFLEBOARD,
  EVENT_FAQ_CONST.MISC_ACTIVITIES,
  EVENT_FAQ_CONST.IS_21ST_BDAY_PROHIBITED,
  EVENT_FAQ_CONST.IS_AFTER_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_ALBUM_RELEASE_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_BACHELOR_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_CONCERT_PROHIBITED,
  EVENT_FAQ_CONST.IS_FESTIVAL_HOLIDAY_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_INFLUENCER_EVENT_PROHIBITED,
  EVENT_FAQ_CONST.IS_KIDS_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_SPORTS_VIEWING_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_PARTY_PROHIBITED,
  EVENT_FAQ_CONST.IS_WEDDING_PROHIBITED,
  EVENT_FAQ_CONST.OTHER_PROHIBITED_ACTIVITY];

export const EVENT_RULES_PROPS = [EVENT_FAQ_CONST.HAS_QUIET_HOURS,
  EVENT_FAQ_CONST.LOUD_MUSIC_ENDS_BY,
  EVENT_FAQ_CONST.HAS_FLEXIBLE_HOURS,
  EVENT_FAQ_CONST.IS_GLITTER_ALLOWED,
  EVENT_FAQ_CONST.IS_HIRED_SECURITY_REQUIRED,
  EVENT_FAQ_CONST.ARE_OPEN_FLAMES_ALLOWED,
  EVENT_FAQ_CONST.ARE_PETS_ALLOWED,
  EVENT_FAQ_CONST.IS_SMOKING_ALLOWED,
  EVENT_FAQ_CONST.ARE_TICKETED_EVENTS_ALLOWED,
  EVENT_FAQ_CONST.OTHER_EVENT_RULES];
